import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import NewsCategoryCreateEditForm from './Components/NewsCategoryCreateEditForm';
import NewsCategoryApi from './NewsCategoryApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: NewsCategoryCreateEditForm,
                getCreate: NewsCategoryApi.create,
                defaults: {},
                successMessage: "NewsCategory Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}